/**
 * apps/web/src/lib/strings/index.ts
 *
 * Dictionary registry. Components read the ACTIVE dictionary through the
 * `useStrings()` hook (see ../../i18n/LanguageProvider) so the UI re-renders on
 * a language switch. The bare `strings` export below is a Italian-default
 * fallback for the few non-React modules and tests that cannot call a hook.
 */

import { it } from './it';
import { en } from './en';

export type { Strings } from './it';
export { it, en };

/** Supported UI languages. */
export type Lang = 'it' | 'en';

/** Active dictionary per language. */
export const dictionaries: Record<Lang, typeof it> = { it, en };

/**
 * Italian-default dictionary for non-reactive contexts (tests, module-scope
 * helpers). Reactive UI must use `useStrings()` instead so it follows the
 * language switch.
 */
export const strings = it;
